import { LayoutDimension } from "./types";

export const httpStatusOptions = ["1XX", "2XX", "3XX", "4XX", "5XX"] as const;

export const defaultLayoutDimensions: LayoutDimension = {
  left: 0,
  right: 0,
  top: 3,
  bottom: 19,
  height: 300,
  ticksLeft: 5
};

export const httpMetricsQueryFields = [
  {
    name: "request.count",
    expr: "SUM(`http.request`)"
  },
  {
    name: "request.rate",
    expr: "SUM(`http.request`) / `interval`"
  },
  {
    name: "response.count",
    expr: "SUM(`http.response`)"
  },
  {
    name: "response.status",
    expr: "SUM(`http.response`, 'http.response.code')"
  },
  {
    name: "request.bytes",
    expr: "SUM(`app.http.request.header.size` + `app.http.request.body.size`)"
  },
  {
    name: "response.bytes",
    expr: "SUM(`app.http.response.header.size` + `app.http.response.body.size`)"
  },
  {
    name: "bandwidth.total.bytes",
    expr: "SUM(`app.http.request.header.size` + `app.http.request.body.size` + `app.http.response.header.size` + `app.http.response.body.size`)"
  },
  {
    name: "bandwidth.avg.bytes",
    expr: "AVG(`app.http.request.header.size` + `app.http.request.body.size` + `app.http.response.header.size` + `app.http.response.body.size`)"
  },
  {
    name: "request.url.method.count",
    expr: "SUM(`http.request`, 'http.request.url', 'http.request.method')"
  },
  {
    name: "request.url.method.impact",
    expr: "100 * (SUM(`http.request`, 'http.request.url', 'http.request.method') / MAX(SUM(`http.request`)))"
  },
  {
    name: "request.url.method.duration.avg",
    expr: "AVG(`tracing.duration`, 'http.request.url', 'http.request.method')"
  },
  {
    name: "request.url.method.duration.p95",
    expr: "QUANTILE(SUM(`tracing.duration`, 'http.request.url', 'http.request.method'), 0.95)"
  }
];

export const httpMetricsQueryFilters = [
  {
    key: "kind",
    value: "SERVER"
  }
];
